// Module
var code = "<wt-generic-select items=\"vm.items\" model=\"vm.model\" on-change=\"vm.onChange()\"> </wt-generic-select>";
// Exports
module.exports = code;